const BrandsSection = ({ imgBase }) => (
  <section className="border-y border-slate-100 bg-white py-24">
    <div className="container mx-auto px-6 text-center">
      <p className="mb-16 text-[10px] font-bold uppercase tracking-[0.4em] text-slate-400">
        Especialidades e Identidad
      </p>
      <div className="mx-auto grid max-w-5xl grid-cols-1 items-center gap-12 md:grid-cols-3">
        <div className="group flex flex-col items-center">
          <div className="mb-6 flex h-24 w-full items-center justify-center grayscale transition-all duration-500 group-hover:grayscale-0">
            <img src={`${imgBase}logo_unryukai.png`} alt="Unryu" className="h-full w-auto object-contain" />
          </div>
          <p className="text-xs font-bold uppercase tracking-widest text-slate-400">Legado Soke Masaaki Hatsumi</p>
        </div>
        <div className="group flex flex-col items-center">
          <div className="mb-6 flex h-24 w-full items-center justify-center grayscale transition-all duration-500 group-hover:grayscale-0">
            <img src={`${imgBase}logo_bujinkan.png`} alt="Bujinkan" className="h-full w-auto object-contain" />
          </div>
          <p className="text-xs font-bold uppercase tracking-widest text-slate-400">Artes marciales<br />tradicionales japonesas</p>
        </div>
        <div className="group flex flex-col items-center">
          <div className="mb-6 flex h-24 w-full items-center justify-center grayscale transition-all duration-500 group-hover:grayscale-0">
            <img src={`${imgBase}logo_balance.png`} alt="Balance" className="h-full w-auto object-contain" />
          </div>
          <p className="text-xs font-bold uppercase tracking-widest text-slate-400">Terapias naturales<br/>Métodos de salud</p>
        </div>
      </div>
    </div>
  </section>
);

export default BrandsSection;
